import React, { useEffect } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";

const isInsidePortugal = (lat, lng) => {
  // Portugal Continental
  const mainland =
    lat >= 36.8 &&
    lat <= 42.2 &&
    lng >= -9.6 &&
    lng <= -6.0;

  // Madeira
  const madeira =
    lat >= 32.5 &&
    lat <= 32.9 &&
    lng >= -17.4 &&
    lng <= -16.5;

  // Açores
  const azores =
    lat >= 36.8 &&
    lat <= 39.9 &&
    lng >= -31.5 &&
    lng <= -24.5;

  return mainland || madeira || azores;
};

const LeafletGeocoder = ({ setPosition }) => {
  const map = useMap();

  useEffect(() => {
    const geocoder = L.Control.geocoder({
      defaultMarkGeocode: false,
      showResultIcons: true,
      showUniqueResult: true,

      geocoder: L.Control.Geocoder.nominatim({
        serviceUrl: "https://nominatim.openstreetmap.org/",
        geocodingQueryParams: {
          countrycodes: "pt",
          addressdetails: 1,
        },
      }),
    })
      .on("markgeocode", (e) => {
        const latlng = e.geocode.center;

        if (!latlng) {
          return;
        }

        const lat = Number(latlng.lat);
        const lng = Number(latlng.lng);

        // Bloquear qualquer resultado fora de Portugal
        if (!isInsidePortugal(lat, lng)) {
          console.warn("Localização fora de Portugal:", lat, lng);
          return;
        }

        const position = {
          lat,
          lng,
        };

        setPosition(position);

        map.flyTo(position, 15, {
          animate: true,
        });
      })
      .addTo(map);

    return () => {
      map.removeControl(geocoder);
    };
  }, [map, setPosition]);

  return null;
};

export default LeafletGeocoder;